import { formatDate, parseLocalDateString } from 'bernie-l10n';
import { format } from 'date-fns';
export function getIsoDateString(dateString) {
  var isoDateString = null;
  if (dateString) {
    var fragments = dateString.split('/');
    var month = fragments[0].length === 2 ? fragments[0] : "0".concat(fragments[0]);
    var day = fragments[1].length === 2 ? fragments[1] : "0".concat(fragments[1]);
    isoDateString = "".concat(fragments[2], "-").concat(month, "-").concat(day);
  }
  return isoDateString;
}
export function getIsoDateFromBexDate(date) {
  return getIsoDateString("".concat(date.month, "/").concat(date.day, "/").concat(date.year));
}
export function getDateObjectFromDateString(dateString, localDateFormat) {
  var isoDateObj = parseLocalDateString(dateString, {
    raw: localDateFormat
  });
  if (!isoDateObj) {
    isoDateObj = parseLocalDateString(dateString, {
      raw: 'yyyy-MM-dd'
    });
  }
  return isoDateObj;
}
export function getIsoFormatDateFromDateString(dateString, localDateFormat) {
  var isoDateObj = dateString && getDateObjectFromDateString(dateString, localDateFormat);
  return isoDateObj && formatDate(isoDateObj, {
    raw: 'yyyy-MM-dd'
  });
}
export function isValidDate(date) {
  return date && !isNaN(date.getTime());
}
export function isValidDateString(dateString, localDateFormat) {
  var isValid = false;
  if (dateString) {
    var isoFormatDate = getDateObjectFromDateString(dateString, localDateFormat);
    isValid = isoFormatDate && isValidDate(isoFormatDate);
  }
  return isValid;
}
export function fromJSDateToISODateString(date) {
  return format(date, 'yyyy-MM-dd');
}
export function addDays(date, days) {
  date.setDate(date.getDate() + days);
  return date;
}
export function getTodayDateBexFormat() {
  var today = new Date();
  return {
    day: today.getDate(),
    month: today.getMonth() + 1,
    year: today.getFullYear()
  };
}